import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58ff5d7e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=58ff5d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff5d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ff5d7e')) {
      api.createRecord('58ff5d7e', component.options)
    } else {
      api.reload('58ff5d7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58ff5d7e&scoped=true&", function () {
      api.rerender('58ff5d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/to-review-log/index.vue"
export default component.exports